<template>
  <div class="indexPage">
    <!-- 导航 -->
    <div class="topNav" :style="navStyle">
      <div class="topBox">
        <img
          class="tbLeft"
          @click="togglePage(1)"
          :src="
            logoTop === 1
              ? 'http://cdn.xiyundata.com/versions1_1_0/icons/logo01.png'
              : 'http://cdn.xiyundata.com/versions1_1_0/icons/logo02.png'
          "
          alt=""
        />
        <div class="tbRight">
          <!-- <div
            :style="navStyleItem"
            class="tbRightItem"
            @click="togglePage(1)"
            :class="activeIndex == 1 ? 'activeNav' : ''"
          >
            首页
          </div> -->
          <div
            :style="navStyleItem"
            class="tbRightItem"
            @click="togglePage(2)"
            :class="activeIndex == 2 ? 'activeNav' : ''"
          >
            关于数港
          </div>
          <div
            :style="navStyleItem"
            class="tbRightItem"
            @click="togglePage(3)"
            :class="activeIndex == 3 ? 'activeNav' : ''"
          >
            解决方案
          </div>
          <div
            :style="navStyleItem"
            class="tbRightItem"
            @click="togglePage(4)"
            :class="activeIndex == 4 ? 'activeNav' : ''"
          >
            产品中心
          </div>
          <div
            :style="navStyleItem"
            class="tbRightItem"
            @click="togglePage(5)"
            :class="activeIndex == 5 ? 'activeNav' : ''"
          >
            服务保障
          </div>
          <div
            :style="navStyleItem"
            class="tbRightItem"
            @click="togglePage(6)"
            :class="activeIndex == 6 ? 'activeNav' : ''"
          >
            联系我们
          </div>
        </div>
      </div>
    </div>
    <!-- 移动端-导航按钮 -->
    <div class="mobile-nav-button">
      <div class="mobile-nav-btn-content">
        <img
          class="tbLeft"
          style="margin-left: 22px"
          @click="togglePage(1)"
          src="http://cdn.xiyundata.com/versions1_1_0/icons/logo02.png"
          alt=""
        />
        <div @click="openMobileNav" class="mNavIcon">
          <div class="foldBox">
            <div class="foldItem"></div>
            <div class="foldItem"></div>
            <div class="foldItem"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 移动端-导航弹窗 -->
    <div class="mobile-nav" v-if="showMobileNav">
      <div class="mobile-nav-overlay" @click="closeMobileNav"></div>
      <div class="mobile-nav-content">
        <div
          @click="closeMobileNav"
          class="tbRightItem mobile-nav-item"
          style="
            color: black;
            margin-left: 15px;
            display: flex;
            justify-content: flex-end;
          "
        >
          <i style="font-size: 30px" class="el-icon-close"></i>
        </div>
        <div
          style="color: black; margin-left: 15px; font-size: 16px"
          class="tbRightItem mobile-nav-item"
          :class="activeIndex == 2 ? 'activeNav' : ''"
          @click="togglePage2(2)"
        >
          关于数港
        </div>
        <div
          style="color: black; margin-left: 15px; font-size: 16px"
          class="tbRightItem mobile-nav-item"
          :class="activeIndex == 3 ? 'activeNav' : ''"
          @click="togglePage2(3)"
        >
          解决方案
        </div>
        <div
          style="color: black; margin-left: 15px; font-size: 16px"
          class="tbRightItem mobile-nav-item"
          :class="activeIndex == 4 ? 'activeNav' : ''"
          @click="togglePage2(4)"
        >
          产品中心
        </div>
        <div
          style="color: black; margin-left: 15px; font-size: 16px"
          class="tbRightItem mobile-nav-item"
          :class="activeIndex == 5 ? 'activeNav' : ''"
          @click="togglePage2(5)"
        >
          服务保障
        </div>
        <div
          style="color: black; margin-left: 15px; font-size: 16px"
          class="tbRightItem mobile-nav-item"
          :class="activeIndex == 6 ? 'activeNav' : ''"
          @click="togglePage2(6)"
        >
          联系我们
        </div>
      </div>
    </div>
    <!-- 页面 -->
    <HomeComponent v-if="activeIndex == 1" @go-to-page="handleGoToPage"></HomeComponent>
    <AboutComponent v-if="activeIndex == 2"></AboutComponent>
    <CoreComponent v-if="activeIndex == 3"></CoreComponent>
    <ProductComponent v-if="activeIndex == 4"></ProductComponent>
    <QualityComponent v-if="activeIndex == 5"></QualityComponent>
    <CraneComponent v-if="activeIndex == 6"></CraneComponent>
    <!-- 底部 -->
    <div class="homeFooter">
      <div class="homeFooterContent">
        <div class="footerBox1">
          <div class="fb1A">
            <div class="fb1ATop">行业与趋势洞察<br />制定数智化升级战略</div>
            <div class="fb1AMid">
              电话：18017562278<br />邮箱：liujian@xiyundata.com
            </div>
          </div>
          <div class="fb1BBox">
            <div class="fb1B">
              <div @click="footerClick(4)" class="fb1BTop">产品</div>
              <div @click="footerClick(4)" class="fb1BBom">工业物联应变仪</div>
              <div @click="footerClick(4)" class="fb1BBom">网关采集器</div>
              <div @click="footerClick(4)" class="fb1BBom">路由器</div>
              <div @click="footerClick(4)" class="fb1BBom">应力传感器</div>
            </div>
            <div class="fb1B">
              <div @click="footerClick(5)" class="fb1BTop">服务与支持</div>
              <div @click="footerClick(5)" class="fb1BBom">服务保障</div>
              <div @click="footerClick(3)" class="fb1BBom">解决方案</div>
            </div>
            <div class="fb1B" style="flex: 0.8">
              <div @click="footerClick(2)" class="fb1BTop">关于数港</div>
              <div @click="footerClick(1)" class="fb1BBom">DIGITAL PORT</div>
              <div @click="footerClick(6)" class="fb1BBom">联系我们</div>
            </div>
          </div>
        </div>
        <div class="footerBox2"></div>
        <div class="footerBox3">
          <div class="f3Item">
            © 2025 数港 | 保留所有权利 |
            <span @click="goPage1" class="linkTxt">苏ICP备2024137665号-1</span>
          </div>
          <!-- <div @click="goPage2" class="f3Item linkTxt">沪公网安备 310105020089879号</div> -->
        </div>
      </div>
    </div>
    <!-- 回到顶部按钮 -->
    <div class="scollButton" :style="toTopStyle" @click="toTopClick"></div>
  </div>
</template>

<script>
import HomeComponent from "@/views/home.vue";
import AboutComponent from "@/views/about.vue";
import CoreComponent from "@/views/core.vue";
import ProductComponent from "@/views/product.vue";
import QualityComponent from "@/views/quality.vue";
import CraneComponent from "@/views/crane.vue";
import "@/assets/style.css";
export default {
  data() {
    return {
      activeIndex: 1,
      swiperIndex: 1,
      navStyle: {},
      navStyleItem: {},
      toTopStyle: { display: "block" },
      logoTop: 1,
      showMobileNav: false, // 控制弹窗显示
    };
  },
  components: {
    HomeComponent,
    AboutComponent,
    CoreComponent,
    ProductComponent,
    QualityComponent,
    CraneComponent,
  },
  watch: {
    activeIndex: function (newValue) {
      console.log(newValue)
      // if (newValue > 2) {
      //   this.navStyle = { backgroundColor: "#fff" };
      //   this.navStyleItem = { color: "#000" };
      //   this.logoTop = 2;
      // } else {
        this.navStyle = { backgroundColor: "transparent" };
        this.navStyleItem = { color: "#fff" };
        this.logoTop = 1;
      // }
    },
  },
  methods: {
    handleScroll() {
      const scrollHeight =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollHeight > 65) {
        this.navStyle = { backgroundColor: "#fff" };
        this.navStyleItem = { color: "#000" };
        this.logoTop = 2;
      } else {
        // if (this.activeIndex > 2) {
        //   this.navStyle = { backgroundColor: "#fff" };
        //   this.navStyleItem = { color: "#000" };
        //   this.logoTop = 2;
        // } else {
          this.navStyle = { backgroundColor: "transparent" };
          this.navStyleItem = { color: "#fff" };
          this.logoTop = 1;
        // }
      }
    },
    togglePage(index) {
      this.activeIndex = index;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    toTopClick() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    // 打开弹窗
    openMobileNav() {
      this.showMobileNav = true;
    },
    // 关闭弹窗
    closeMobileNav() {
      this.showMobileNav = false;
    },
    // 切换页面
    togglePage2(index) {
      this.activeIndex = index;
      this.closeMobileNav(); // 切换页面后关闭弹窗
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    goPage1() {
      window.open('https://beian.miit.gov.cn/')
    },
    goPage2() {
      window.open('https://www.nmpa.gov.cn/')
    },
    footerClick(type) {
      this.activeIndex = type;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleGoToPage(index) {
      this.togglePage(index);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    // this.toTopStyle = { display: "none" };
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
/* 确保页面内容不超过视口大小 */
.indexPage {
  overflow: auto;
  overflow-x: hidden;
}

/* 对于Firefox */
.indexPage {
  scrollbar-width: none; /* Firefox */
}

/* 对于Chrome, Safari 和 Opera */
.indexPage::-webkit-scrollbar {
  display: none;
}

.topNav {
  display: flex;
  justify-content: center;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 70px;
  background-color: transparent;
  transition: background-color 0.5s ease;
  /* background-color: rgba(0, 0, 0, .85); */
}
.topBox {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1200px;
  background-color: transparent;
}
.tbLeft {
  cursor: pointer;
  width: 106px;
  height: 26px;
}
.tbRight {
  height: 100%;
  display: flex;
  margin-left: 26px;
}
.tbRightItem {
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 100%;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  margin-left: 40px;
  padding: 0 14px;
  transition: color 0.5s ease, background-color 0.5s ease; /* 添加过渡效果 */
}
.tbRightItem:hover {
  color: #DA0010 !important;
}
.activeNav {
  position: relative;
  color: #DA0010 !important;
}

.el-carousel__item {
}

.homeFooter {
  padding-top: 50px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 70vh;
  background: #f3f3f3;
}
.homeFooterContent {
  width: 1200px;
  height: 100%;
}
.footerBox1 {
  width: 100%;
  display: flex;
  margin-bottom: 80px;
}
.fb1A {
  flex: 1;
}
.fb1ATop {
  font-size: 32px;
  line-height: 1.5;
  color: #262626;
}
.fb1AMid {
  font-size: 14px;
  line-height: 20px;
  margin-top: 15px;
  color: #404040;
}
.fb1BBox {
  flex: 1.3;
  display: flex;
}
.fb1B {
  flex: 1;
}
.fb1BTop {
  cursor: pointer;
  font-size: 20px;
  margin-bottom: 40px;
  color: #262626;
}
.fb1BBom {
  font-size: 16px;
  margin-bottom: 40px;
  color: #262626;
  font-weight: 300;
  cursor: pointer;
}
.fb1BBom:hover {
  color: #DA0010;
}
.footerBox2 {
  width: 100%;
  height: 1.2px;
  background-color: #a6a6a6;
  margin-top: 24px;
  margin-bottom: 24px;
}
.footerBox3 {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.f3Item {
  color: #262626;
  font-size: 12px;
  font-weight: 300;
}
.linkTxt {
  cursor: pointer;
}

.scollButton {
  width: 42px;
  height: 62px;
  background-image: url(http://cdn.xiyundata.com/versions1_1_0/icons/topIcon.png);
  background-size: 100% 100%;
  background-position: 50%;
  position: fixed;
  left: calc(50% + 650px);
  bottom: 150px;
  transform: translateX(-100%);
  z-index: 100;
  cursor: pointer;
}

/* 移动端导航按钮样式 */
.mobile-nav-button {
  display: none;
  justify-content: center;
  align-items: center;
  width: 100vw;
  box-sizing: border-box;
  height: 58px;
  background-color: #fff;
  position: fixed;
  top: 0px;
  right: 0px;
  z-index: 100;
}
.mobile-nav-btn-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 95%;
  height: 100%;
}

/* 弹窗样式 */
.mobile-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.mobile-nav-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
}

.mobile-nav-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1002;
  background-color: #fff;
  width: 100vw;
  height: 100vh;
  max-width: 270px;
  padding: 20px;
  padding-top: 20px;
  box-sizing: border-box;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.mobile-nav-item {
  width: 88%;
  height: 40px;
  padding: 10px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}
.el-icon-s-fold {
  font-size: 36px;
  margin-top: 8px;
  margin-right: 8px;
}
.mNavIcon {
  cursor: pointer;
  padding: 20px;
}
.foldBox {
  padding-top: 5px;
}
.foldItem {
  width: 26px;
  height: 1.5px;
  background-color: #262626;
  border-radius: 0.5px;
  margin-bottom: 6px;
}

/* 媒体查询，屏幕宽度小于830px */
@media (max-width: 830px) {
  .topNav {
    display: none;
  }
  .scollButton {
    left: 96vw; /* 调整回到顶部按钮的位置 */
  }
  .footerBox1 {
    display: block;
    margin-bottom: 10px;
  }
  .homeFooterContent {
    width: 88%;
  }
  .footerBox3 {
    display: block;
    line-height: 1.6;
  }
  .fb1ATop {
    font-size: 20px;
  }
  .fb1AMid {
    font-size: 14px;
  }
  .fb1BTop {
    font-size: 14px;
    margin-bottom: 14px;
  }
  .fb1BBom {
    font-size: 12px;
    margin-bottom: 14px;
  }
  .fb1BBox {
    margin-top: 18px;
  }
  .footerBox2 {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .tbLeft {
    width: 90px;
    height: 22px;
  }
}

/* 媒体查询，屏幕宽度小于830px */
@media (max-width: 830px) {
  .mobile-nav-button {
    display: flex;
  }
  /* 隐藏原导航栏 */
  .topNav {
    display: none;
  }
}
</style>
